import React from 'react';

const PrivacyPolicy = ({ darkMode }) => {
  return (
    <div className={`privacy-policy ${darkMode ? 'dark' : ''}`}>
      <div className="legal-container">
        <h1>🔒 Zásady ochrany osobných údajov</h1>
        
        <div className="legal-section">
          <h2>📊 Aké údaje zbierame</h2>
          <ul>
            <li>Email adresu pri prihlásení na odber citátov</li>
            <li>Meno (voliteľné) pre personalizáciu emailov</li>
            <li>Cookies pre funkčnosť stránky a reklamy</li>
            <li>Analytické údaje cez Google Analytics</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>🎯 Ako používame vaše údaje</h2>
          <ul>
            <li>Posielanie denných motivačných citátov</li>
            <li>Zlepšovanie používateľskej skúsenosti</li>
            <li>Zobrazovanie relevantných reklám</li>
            <li>Analýza návštevnosti stránky</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>🍪 Cookies</h2>
          <p>
            Používame cookies pre:
          </p>
          <ul>
            <li>Uchovanie vašich nastavení (dark mode, obľúbené citáty)</li>
            <li>Google Analytics na analýzu návštevnosti</li>
            <li>Google AdSense na zobrazenie reklám</li>
            <li>Funkčnosť stránky a používateľskú skúsenosť</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>📢 Google AdSense</h2>
          <p>
            Táto stránka používa Google AdSense na zobrazenie reklám. 
            Google môže používať cookies na zobrazenie relevantných reklám 
            na základe vašich predchádzajúcich návštev našej stránky a iných stránok.
          </p>
          <p>
            Môžete sa odhlásiť z personalizovaných reklám na stránke{' '}
            <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
              Google Ads Settings
            </a>.
          </p>
        </div>

        <div className="legal-section">
          <h2>🔐 Ochrana údajov</h2>
          <ul>
            <li>Vaše údaje sú šifrované a bezpečne uložené</li>
            <li>Nezdieľame vaše údaje s tretími stranami</li>
            <li>Máte právo na prístup, opravu alebo vymazanie údajov</li>
            <li>Môžete sa kedykoľvek odhlásiť z odberu emailov</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>📧 Kontakt</h2>
          <p>
            Pre otázky týkajúce sa ochrany osobných údajov nás kontaktujte na:{' '}
            <a href="mailto:namotivujma@gmail.com">namotivujma@gmail.com</a>
          </p>
        </div>

        <div className="legal-section">
          <h2>🔄 Aktualizácie</h2>
          <p>
            Tieto zásady môžu byť občas aktualizované. 
            Posledná aktualizácia: {new Date().toLocaleDateString('sk-SK')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
